import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeLangAction } from "../../actions/WelcomeActions";
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';

class BottomLangDropDown extends Component {
    handleChangeLang(event){
        this.props.changeLang(event);

        this.props.changeLangAction({
            currentLang: event
        });
        this.setState({})
    }
    render() {
        return (
            <div className="bottom-lang-container">
                <ul>
                {this.props.languageData.map((item, idx) => {
                        return(
                            <li key={idx} onClick={() => this.handleChangeLang(item.lang)}>
                                <span className={(config.lang == item.lang) ? 'activeLang' : ''}>
                                <FormattedMessage id={item.formatId}
                                    defaultMessage={item.formatDefaultMsg}
                                />
                            </span>
                            </li>
                        )
                    }
                )}
                </ul>
                <div className="lang-close-btn" onClick={()=> this.props.onClose()}>
                    <i className="fa fa-times-circle" style={{pointerEvents: "none"}} />
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
          changeLangAction
        },
        dispatch
      );
};
export default connect(mapStateToProps, mapDispatchToProps)(BottomLangDropDown);



// WEBPACK FOOTER //
// ./src/components/BottomLangDropDown/BottomLangDropDown.js